/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListAllAnimalsForOfflineQueryResponse, ListAllAnimalsForOfflinePathParams, ListAllAnimalsForOfflineQueryParams, ListAllAnimalsForOffline400, ListAllAnimalsForOffline401, ListAllAnimalsForOffline403, ListAllAnimalsForOffline404, ListAllAnimalsForOffline409, ListAllAnimalsForOffline500 } from "../../types/livestockController/ListAllAnimalsForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListAllAnimalsForOfflineUrl(organizationId: ListAllAnimalsForOfflinePathParams["organizationId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/animals/all` as const }
  return res
}

/**
 * @summary Full non-paginated animal dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/animals/all}
 */
export async function listAllAnimalsForOffline(organizationId: ListAllAnimalsForOfflinePathParams["organizationId"], params?: ListAllAnimalsForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListAllAnimalsForOfflineQueryResponse, ResponseErrorConfig<ListAllAnimalsForOffline400 | ListAllAnimalsForOffline401 | ListAllAnimalsForOffline403 | ListAllAnimalsForOffline404 | ListAllAnimalsForOffline409 | ListAllAnimalsForOffline500>, unknown>({ method : "GET", url : getListAllAnimalsForOfflineUrl(organizationId).url.toString(), params, ... requestConfig })
  return res.data
}